"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SankeyUtils = require("./SankeyUtils");

var _types = require("./types");

var SankeyLinkContextMenuPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  closeLinkContextMenu: _propTypes.default.func.isRequired,
  selected_link: _propTypes.default.shape(_types.SankeyLinkPropTypes).isRequired,
  show: _propTypes.default.bool.isRequired
};

var SankeyLinkContextMenu = function SankeyLinkContextMenu(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      closeLinkContextMenu = _ref.closeLinkContextMenu,
      selected_link = _ref.selected_link,
      show = _ref.show;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    size: "sm",
    show: show,
    onHide: closeLinkContextMenu
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    vertical: true,
    style: {
      'marginLeft': '10px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    onClick: function onClick() {
      (0, _SankeyUtils.delete_link)(data, selected_link);
      set_data((0, _objectSpread2.default)({}, data));
      closeLinkContextMenu();
    }
  }, "Supprimer flux"))));
};

var _default = SankeyLinkContextMenu;
exports.default = _default;